import React from 'react';
import { FiUsers, FiStar } from 'react-icons/fi';
import { useReservation } from '../contexts/ReservationContext';
import './Vehicles.css';

const vehicles = [
  {
    id: 'hummer',
    name: 'Hummer H3 Stretch',
    category: 'Limousine Stretch',
    capacity: 'Jusqu\'à 8 passagers',
    description: 'L\'icône des soirées et mariages, intérieur lounge avec bar et système son.',
    image: '/images/gallery/hummer-limousine-place-vendome-paris.webp',
    alt: 'Limousine Hummer H3 stretch blanche Place Vendôme Paris',
    popular: true
  },
  {
    id: 'rolls',
    name: 'Rolls Royce Phantom',
    category: 'Ultra Luxe',
    capacity: '4 passagers',
    description: 'Le summum du luxe automobile, ciel étoilé et finitions artisanales.',
    image: '/images/gallery/rolls-royce-phantom-place-vendome-paris.webp',
    alt: 'Rolls Royce Phantom blanche Place Vendôme Paris'
  },
  {
    id: 'chrysler',
    name: 'Chrysler 300 Stretch',
    category: 'Limousine Stretch',
    capacity: 'Jusqu\'à 8 passagers',
    description: 'L\'élégance américaine, parfaite pour mariages et bals de promo.',
    image: '/images/gallery/limousine-chrysler-place-vendome-paris.webp',
    alt: 'Limousine Chrysler 300 stretch blanche Place Vendôme Paris'
  },
  {
    id: 'mercedes',
    name: 'Mercedes Classe S',
    category: 'Berline Luxe',
    capacity: '3 passagers',
    description: 'La référence des transferts d\'affaires et VIP, confort absolu.',
    image: '/images/gallery/limousine-blanche-place-vendome-nuit.webp',
    alt: 'Mercedes Classe S berline de luxe Place Vendôme nuit Paris'
  },
  {
    id: 'citroen',
    name: 'Citroën 2CV Vintage',
    category: 'Voiture Vintage',
    capacity: '3 passagers',
    description: 'L\'authenticité française rétro pour mariages originaux et photoshoots.',
    image: '/images/gallery/citroen-2cv-vintage-paris-mariage.webp',
    alt: 'Citroën 2CV vintage mariage Paris'
  }
];

const Vehicles = () => {
  const { open } = useReservation();

  return (
    <section className="vehicles section-padding">
      <div className="container">
        <div className="section-header text-center">
          <span className="section-badge">Notre Flotte</span>
          <h2 className="section-title">
            Limousines & Voitures
            <span className="title-accent">de Luxe Paris</span>
          </h2>
        </div>

        <div className="vehicles-grid">
          {vehicles.map((v) => (
            <article key={v.id} className={`vehicle-card ${v.popular ? 'popular' : ''}`}>
              {v.popular && (
                <div className="popular-badge">
                  <FiStar size={14} />
                  <span>Populaire</span>
                </div>
              )}

              <div className="vehicle-image">
                <img
                  src={v.image}
                  alt={v.alt}
                  className="vehicle-photo"
                  loading="lazy"
                  width="800"
                  height="600"
                />
              </div>

              <div className="vehicle-content">
                <span className="vehicle-category">{v.category}</span>
                <h3 className="vehicle-name">{v.name}</h3>
                <p className="vehicle-description">{v.description}</p>

                <div className="vehicle-capacity">
                  <FiUsers size={16} />
                  <span>{v.capacity}</span>
                </div>

                <button
                  type="button"
                  className="btn btn-outline vehicle-btn"
                  onClick={() => open({ typeVehicule: v.name })}
                >
                  Réserver ce véhicule
                </button>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Vehicles;
